<template>
  <div class="powered-by">
    <FriedButton
      class="powered-by-button"
      data-external="signing-page-mobile-powered-by-button"
      :aria-label="$t('powered-by-getaccept')"
      :button-type="ButtonType.Secondary"
      @click="goToGetAccept"
    >
      <PoweredByLogo />
    </FriedButton>
  </div>
</template>
<script lang="ts">
import { ButtonType } from '@getaccept/fried-tofu';
import { defineComponent } from 'vue';
import PoweredByLogo from '../assets/powered-by-ga.svg';

export default defineComponent({
  components: {
    PoweredByLogo,
  },
  setup() {
    const goToGetAccept = () => {
      window.open('https://www.getaccept.com');
    };
    return { goToGetAccept, ButtonType };
  },
});
</script>
<style lang="scss" scoped>
$powered-by-icon-height: 36px;

.powered-by {
  display: flex;
  justify-content: center;
  height: calc(#{$powered-by-icon-height} + #{var(--spacing-200)});
  padding: var(--spacing-100) 0;

  .powered-by-button {
    border: none;
    background-color: var(--white);
    height: 100%;

    &:focus {
      outline-color: var(--gray-96);
    }
  }

  .powered-by-icon {
    animation: bounce 0.5s;
  }
}

@keyframes bounce {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}
</style>
